<template>
  <div id="SideBar">
    <v-card tile class="mx-auto menu-card" :width="isCollapsed ? 50 : 220">
      <v-navigation-drawer color="#0F416E" dark permanent>
        <v-list class="pb-12">
          <v-list-item-group mandatory color="white">
            <template v-for="(item, index) in menuItemsByRole">
              <v-menu
                v-if="item.children.length > 0 && isCollapsed"
                nudge-right="10"
                min-width="100"
                open-on-hover
                close-delay="50"
                :key="index"
                offset-x
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item :to="item.router" mouse v-on="on" v-bind="attrs" link>
                    <v-list-item-icon class="px-0 mx-0">
                      <v-icon small>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="menu-list-title">{{ item.title }} </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>

                <v-list>
                  <v-list-item-group>
                    <template v-for="(childItem, childIndex) in item.children">
                      <v-list-item :key="childIndex" :to="childItem.router" exact>
                        <v-list-item-content>
                          <v-list-item-title
                            ><span class="menu-child-list-title">
                              {{ childItem.title }}
                            </span>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                </v-list>
              </v-menu>

              <v-list-group v-else-if="item.children.length > 0 && !isCollapsed" :key="index" color="white">
                <template v-slot:appendIcon>
                  <v-icon small>mdi-chevron-down</v-icon>
                </template>
                <template v-slot:activator>
                  <v-list-item-icon class="mx-0">
                    <v-icon small>{{ item.icon }}</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title class="menu-list-title">{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <template v-for="(childItem, index) in item.children">
                  <v-list-item class="pl-10" :to="childItem.router" exact :key="index">
                    <v-list-item-content>
                      <v-list-item-title class="menu-child-list-title">{{ childItem.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list-group>

              <v-list-item v-else :to="item.router" :key="index" link>
                <v-list-item-icon class="px-0 mx-0">
                  <v-icon small>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="menu-list-title">{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Roles } from '@/consts/Roles';
import { hasPermission } from '@/utils/hasPermission';
export default {
  name: 'SideBar',
  data: () => ({
    Roles,
    menuItems: [
      {
        title: 'Usuários',
        icon: 'mdi-account-group',
        router: '/users',
        children: [],
        role: [Roles.ADMIN]
      },
      {
        title: 'Entregadores',
        icon: 'mdi-run-fast',
        router: '/couriers',
        children: [],
        role: [Roles.ADMIN, Roles.OPERATOR]
      },
      {
        title: 'Embarcadores',
        icon: 'mdi-clipboard-account',
        router: '/shippers',
        children: [],
        role: [Roles.ADMIN, Roles.OPERATOR]
      },
      {
        title: 'Transbordos',
        icon: 'mdi-store',
        router: '/transhipments',
        children: [
          { title: 'Gerenciamento', router: '/transhipments' },
          {
            title: 'Negociações',
            router: '/transhipments/negotiations'
          },
          {
            title: 'Transferir Dados',
            router: '/transhipments/transfer'
          }
        ],
        role: [Roles.ADMIN, Roles.OPERATOR]
      },
      {
        title: 'Importações',
        router: '/imports',
        icon: 'mdi-upload',
        children: [
          { title: 'Importação por Planilha', router: '/imports/shipments-import' },
          { title: 'Importação por Manifesto', router: '/imports/manifest-import' },
          { title: 'Importação Manual', router: '/imports/manual-boarding-import' },
          { title: 'XML das Cte', router: '/imports/xml-cte-import' },
        ],
        role: [Roles.ADMIN, Roles.OPERATOR]
      },
      {
        title: 'Exportações',
        router: '/imports',
        icon: 'mdi-download',
        children: [
          { title: 'Dados NFEs', router: '/shipments/export' },
          { title: 'Canhotos PDF', router: '/receipts-export-pdf' },
          { title: 'Canhotos Imagens', router: '/receipts-export-image' },
          { title: 'XMLs das CTEs', router: '/xmls-ctes-export' }
        ],
        role: [Roles.ADMIN, Roles.OPERATOR]
      },
      {
        title: 'Embarques',
        icon: 'mdi-truck',
        router: '/shipments',
        children: [
          { title: 'Gerenciamento', router: '/shipments' },
          { title: 'Gestão à vista', router: '/shipments/management' }
        ],
        role: [Roles.ADMIN, Roles.OPERATOR]
      },
      {
        title: 'Entregas',
        icon: 'mdi-truck',
        router: '/shipper-deliveries',
        children: [],
        role: [Roles.SHIPPER]
      },
      {
        title: 'Faturas',
        icon: 'mdi-cash',
        router: '/shipper-invoices',
        children: [],
        role: [Roles.SHIPPER]
      },
      {
        title: 'Dados Exportados',
        icon: 'mdi-cloud-upload',
        router: '/shipper-deliveries-export',
        children: [],
        role: [Roles.SHIPPER]
      },
      {
        title: 'Quarentena',
        icon: 'mdi-alert-circle-outline',
        router: '/quarantine',
        children: [
          { title: 'Entregas', router: '/quarantine' },
          { title: 'Transferências', router: '/quarantine/transfer' }
        ],
        role: [Roles.ADMIN, Roles.OPERATOR]
      },
      {
        title: 'Mercadorias a Devolver',
        icon: 'mdi-clipboard-arrow-left',
        router: '/givback',
        children: [],
        role: [Roles.ADMIN, Roles.OPERATOR]
      },
      {
        title: 'Contas a pagar',
        router: '/couriers-accounts-payable',
        icon: 'mdi-cash',
        children: [
          { title: 'Adicionais', router: '/financial/aditionals' },
          { title: 'Entregadores a pagar', router: '/couriers-accounts-payable' },
          { title: 'Transbordos a pagar', router: '/transhipment-accounts-payable' },
          { title: 'Ordens de Pagamento', router: '/payment-orders' }
        ],
        role: [Roles.ADMIN, Roles.OPERATOR]
      },
      {
        title: 'Contas a receber',
        router: '/financial/accounts-receivable/aditionals',
        icon: 'mdi-cash-multiple',
        children: [
          { title: 'Adicionais', router: '/financial/accounts-receivable/aditionals' },
          { title: 'Embarcadores a receber', router: '/financial/shipper-accounts-receivable' },
          { title: 'Faturas', router: '/financial/accounts-receivable/invoices' }
        ],
        role: [Roles.ADMIN, Roles.OPERATOR]
      },
      {
        title: 'Fiscal',
        router: '/fiscal',
        icon: 'mdi-file-document-outline',
        children: [{ title: 'Ctes', router: '/fiscal/ctes' }],
        role: [Roles.ADMIN, Roles.OPERATOR]
      },
      {
        title: 'Backup de Canhotos',
        router: '/receipts-backup',
        icon: 'mdi-cloud-upload-outline',
        children: [],
        role: [Roles.SHIPPER]
      },
      {
        title: 'XMLs Exportados',
        router: '/xmls-export',
        icon: 'mdi-download',
        children: [],
        role: [Roles.SHIPPER]
      }
    ]
  }),

  created() {},

  watch: {},
  computed: {
    ...mapGetters('SidebarStore', ['isCollapsed']),
    ...mapGetters('LoginStore', ['getUserLogged', 'getRole']),
    isLogged() {
      return this.getLogged;
    },
    isAdmin() {
      const user = this.getUserLogged;
      return user.userToken.claims[0].value === 'Admin';
    },
    menuItemsByRole() {
      const roles = this.getRole;
      return this.menuItems.filter((item) => hasPermission(item.role, roles));
    }
  },
  methods: {
    setMenuItems() {
      this.menuItems = this.menuItems.filter((item) => hasPermission(item.role));
    }
  }
};
</script>

<style lang="scss" scoped>
.menu-card {
  transition: width 0.3s;
  height: 100%;
  position: fixed;
  z-index: 1;
  top: 50px;
  left: 0;
  overflow-x: hidden;
  padding-top: 20px;

  .menu-list-title {
    font-size: 0.8rem;
  }
}

.menu-child-list-title {
  font-size: 0.75rem;
}
</style>
